// src/pages/merchant/dashboard/VisitingCardModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchAllCardsThunk,
  fetchTemplatesByGroupThunk,
} from "../../../features/eVisitingCard/VisitingCard.thunk";

export default function VisitingCardModal({ show, onHide, onSelectTemplate }) {
  const dispatch = useDispatch();

  const { cardData, groupTemplates, loading } = useSelector(
    (state) => state.eCard
  );
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (show) {
      dispatch(fetchAllCardsThunk());
    }
  }, [show, dispatch]);

  const promoCard = cardData?.find((c) => c.name === "Promotional Card");
  const groups = promoCard?.groups || [];

  const handleGroupChange = (groupId) => {
    setSelectedGroup(groupId);
    setSelectedTemplate(null);

  if (groupId) {
  dispatch(fetchTemplatesByGroupThunk(groupId)); } };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Select Promotional Background</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading && <p>Loading...</p>}

        {/* GROUP DROPDOWN */}
        <Form.Group className="mb-3">
          <Form.Label>Select Group</Form.Label>
          <Form.Select
            value={selectedGroup}
            onChange={(e) => handleGroupChange(e.target.value)}
          >
            <option value="">Select Group</option>
            {groups.map((g) => (
              <option key={g._id} value={g._id}>
                {g.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* TEMPLATE LIST */}
        {selectedGroup && (
          <div>
            <h5>Select Template</h5>

            <div className="image-grid">
              {groupTemplates.map((t, idx) => (
                <div
                  key={idx}
                  onClick={() =>
                    setSelectedTemplate({
                      imgPath: t.templateImage,
                      colorCode: t.colorCode,
                    })
                  }
                  className={`image-box ${
                    selectedTemplate?.imgPath === t.templateImage
                      ? "active-image"
                      : ""
                  }`}
                >
                  {/* IMAGE */}
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${t.templateImage}`}
                    alt="template"
                  />

                  {/* COLOR PREVIEW CIRCLE */}
                  <div
                    className="color-indicator"
                    style={{ background: `#${t.colorCode}` }}
                  ></div>

                  {/* TEXT INDICATOR */}
                  <small className="text-muted">
                    Text color: {t.colorCode}
                  </small>
                </div>
              ))}
            </div>
          </div>
        )}

        <style>
          {`
            .image-grid {
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
              gap: 15px;
            }
            .image-box {
              padding: 8px;
              border-radius: 10px;
              background: #f7f7f7;
              cursor: pointer;
              border: 2px solid transparent;
              text-align: center;
            }
            .image-box img {
              width: 100%;
              border-radius: 8px;
              aspect-ratio: 3/4;
              object-fit: cover;
            }
            .active-image {
              border-color: #6a5acd;
              box-shadow: 0 0 12px rgba(106, 90, 205, 0.4);
            }
            .color-indicator {
              width: 22px;
              height: 22px;
              border-radius: 50%;
              margin: 6px auto;
              border: 1px solid #999;
            }
          `}
        </style>
      </Modal.Body>

      <Modal.Footer>
        <Button
          disabled={!selectedTemplate}
          onClick={() => {
            onSelectTemplate(
              selectedTemplate.imgPath,
              selectedTemplate.colorCode
            );
            onHide();
          }}
        >
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
